import React from 'react'
import moment from 'moment'
import OnboardingTip from './OnboardingTip'
import Resource from '../Resource'

export default class NewsContainer extends React.Component {
  render() {
    return (
      <div className="screen news screen-flex-wrapper">
        <div className="navigation-bar">
          <div className="title">News</div>
        </div>
        <OnboardingTip text="Get updates from the EL-FIT team and stay up to date on your program." />
        <div className="screen-scroll-content">
          <Resource collection path={['posts']} placeholder={[]}>
            {(items) => (
              <div className="posts">
                {items.map((item) => (
                  <div className="post" key={item.id}>
                    <h3>{item.title}</h3>
                    <div className="date">
                      Posted {moment(item.createdAt).format('MMMM DD, YYYY')}
                    </div>
                    <div
                      className="body"
                      dangerouslySetInnerHTML={{
                        __html: item.body.replace(/href=/g, 'target="_blank" href='),
                      }}
                    />
                  </div>
                ))}
              </div>
            )}
          </Resource>
        </div>
      </div>
    )
  }
}
